export default function createNumberSquareWorker() {
  return new Worker(new URL('./worker.js', import.meta.url));
}
